import React from "react";

const StayCardSkeleton: React.FC = () => {
  return (
    <div className="animate-pulse nc-StayCard group relative dark:bg-neutral-900 border border-neutral-100 dark:border-neutral-800 rounded-2xl overflow-hidden will-change-transform h-80 bg-zinc-300">
      <div className="p-4 space-y-4 h-5"></div>
    </div>
  );
};

export default StayCardSkeleton;
